import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AvatarModule } from '../avatar/avatar.module';

import { MatButtonModule} from '@angular/material/button';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SearchDialog } from './search-dialog.component';
import { DirectivesModule } from '../../directives/directive.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    SearchDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    AvatarModule,
    DirectivesModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    InfiniteScrollModule
  ],
  exports: [
    SearchDialog
  ]
})
export class SearchDialogModule {}
